import { Link } from "react-router-dom";
import { useSite } from "../lib/site";
import { EditableText } from "./EditableText";

export function Footer() {
  const { site } = useSite();
  return (
    <footer className="py-12 px-6 bg-deep border-t border-white/10 text-xs font-mono text-dim">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2" data-testid="footer-brand">
          <span className="text-white font-bold">
            <EditableText k="footer_brand" defaultValue="oVu Cyber" />
          </span>
          <span>&bull; <EditableText k="footer_tagline" defaultValue="High School Student Cybersecurity Portfolio" /></span>
        </div>
        <div className="flex items-center gap-5">
          <a
            href={site.github_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-cyber hover:underline"
            data-testid="footer-github-link"
          >
            <EditableText k="footer_github_link" defaultValue="GitHub" />
          </a>
          <Link to="/" className="text-cyber hover:underline" data-testid="footer-top-link">
            <EditableText k="footer_top_link" defaultValue="Back to top ↑" />
          </Link>
        </div>
      </div>
    </footer>
  );
}
